import {
  StudentDetails,
  StudentDetailsGender,
  StudentDetailsMaritalStatus,
} from '../../components/LandingPage/StudentDetails';
import { RbcGicFormTypeV2 } from './types';

export enum RBCPrefix {
  Mr = 'Mr.',
  Mrs = 'Mrs.',
  Ms = 'Ms.',
}

export const RBC_GIC_FORM_DEFAULT_VALUES: RbcGicFormTypeV2 = {
  emailAddress: '',
  confirmEmailAddress: '',
  letterOfAcceptanceFile: [],
  prefix: '',
  givenName: '',
  surname: '',
  dateOfBirth: '',
  purpose: '',
  employmentStatus: '',
  occupation: '',
  occupationOther: '',
  levelOfStudy: '',
  companyName: '',
  companyPhoneNumber: '',
  phoneNumber: '',
  isMobileNumber: false,
  aptOrSuiteResidential: '',
  numberAndStreetNameResidential: '',
  cityResidential: '',
  stateOrProvinceResidential: '',
  countryResidential: '',
  postalCodeResidential: '',
  isSameAsResidentialAddress: false,
  aptOrSuiteMailing: '',
  numberAndStreetNameMailing: '',
  cityMailing: '',
  stateOrProvinceMailing: '',
  countryMailing: '',
  postalCodeMailing: '',
  passportNumber: '',
  issuingCountry: '',
  issuingPlaceOrAuthority: '',
  expiryDate: '',
  school: '',
  provinceOfStudy: '',
  expectedArrivalDate: '',
  expectedGraduationMonth: '',
  expectedGraduationYear: '',
  isThirdPartyInvestment: '',
  isCanadianResidentForTax: '',
  canadianTaxProvince: '',
  isOtherCountryResidentForTax: '',
  numOfOtherCountryResidentForTax: 1,
  otherCountryResidentForTaxCountry1: '',
  otherCountryResidentForTaxCountry2: '',
  otherCountryResidentForTaxCountry3: '',
  hasPoliticallyImportantPositions: '',
  politicallyImportantFullName: '',
  politicallyImportantRelationship: '',
  politicallyImportantRole: '',
  sourceOfWealth: [],
  gicFundSource: [],
  sourceOfWealthOther: '',
  gicFundSourceOther: '',
};

export const getRBCPrefix = (
  gender: StudentDetailsGender | undefined,
  maritalStatus: StudentDetailsMaritalStatus | undefined,
) => {
  if (gender === StudentDetailsGender.Female) {
    if (maritalStatus === StudentDetailsMaritalStatus.Married) {
      return RBCPrefix.Mrs;
    }
    return RBCPrefix.Ms;
  }
  return RBCPrefix.Mr;
};

export const autoFillDataToRbcFormState = (
  autofillData?: StudentDetails,
): RbcGicFormTypeV2 | undefined => {
  if (!autofillData) {
    const formState: RbcGicFormTypeV2 = {
      ...RBC_GIC_FORM_DEFAULT_VALUES,
    };
    return formState;
  }
  const formState: RbcGicFormTypeV2 = {
    ...RBC_GIC_FORM_DEFAULT_VALUES,
    prefix: getRBCPrefix(autofillData.student?.gender, autofillData.student?.maritalStatus),
    numberAndStreetNameResidential:
      autofillData.residentialAddress?.numberAndStreetName ??
      RBC_GIC_FORM_DEFAULT_VALUES.numberAndStreetNameResidential,
    cityResidential:
      autofillData.residentialAddress?.city ?? RBC_GIC_FORM_DEFAULT_VALUES.cityResidential,
    stateOrProvinceResidential:
      autofillData.residentialAddress?.stateOrProvince ??
      RBC_GIC_FORM_DEFAULT_VALUES.stateOrProvinceResidential,
    countryResidential:
      autofillData.residentialAddress?.country ?? RBC_GIC_FORM_DEFAULT_VALUES.countryResidential,
    postalCodeResidential:
      autofillData.residentialAddress?.postalCode ??
      RBC_GIC_FORM_DEFAULT_VALUES.postalCodeResidential,
    givenName: autofillData.student?.givenName ?? RBC_GIC_FORM_DEFAULT_VALUES.givenName,
    surname: autofillData.student?.surname ?? RBC_GIC_FORM_DEFAULT_VALUES.surname,
    dateOfBirth: autofillData.student.dateOfBirth
      ? autofillData.student.dateOfBirth.toISOString()
      : RBC_GIC_FORM_DEFAULT_VALUES.dateOfBirth,
    phoneNumber: autofillData.contact?.phoneNumber ?? RBC_GIC_FORM_DEFAULT_VALUES.phoneNumber,
    emailAddress: autofillData.contact?.emailAddress ?? RBC_GIC_FORM_DEFAULT_VALUES.emailAddress,
    issuingCountry: autofillData.student?.nationality ?? RBC_GIC_FORM_DEFAULT_VALUES.issuingCountry,
    passportNumber:
      autofillData.passport?.passportNumber ?? RBC_GIC_FORM_DEFAULT_VALUES.passportNumber,
    expiryDate: autofillData.passport?.expiryDate
      ? autofillData.passport.expiryDate.toISOString()
      : RBC_GIC_FORM_DEFAULT_VALUES.expiryDate,
  };
  return formState;
};
